import React, { useEffect, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import CategorySlider from "../../component/categorySlider/CategorySlider";

import itemLogo from "../../Asset/item logo.png";
import Order from "../../component/Order/Order";
import { NavLink, useParams } from "react-router-dom";
import { BACKEND_BASEURL } from "../../db/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingSpinner from "../Loader/LoadingSpinner";
import Counter from "../Order/Counter";
import {
  filterOrderItems,
  selectFilteredOrderItems,
} from "../../redux/features/filter/FilterSlice";
import { useDispatch, useSelector } from "react-redux";

const ItemByCategory = ({
  order,
  setOrder,
  option,
  setOption,
  deliveryDatas,
  tableNo,
}) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const { category } = useParams();
  const dispatch = useDispatch();
  const filteredItems = useSelector(selectFilteredOrderItems);

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;

  const getItemByCategory = async (category) => {
    try {
      setLoading(true);
      const response = await axios.get(`${BACKEND_BASEURL}api/${category}`);
      const updatedProducts = response?.data?.map((product) => ({
        ...product,
        quantity: 1,
      }));

      setData(updatedProducts);
      // console.log(response.data);
      setLoading(false);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      toast.error(message);
      setData("");
      setLoading(false);
    }
  };

  const handleQuantityChange = (itemId, newQuantity) => {
    setData((prevData) =>
      prevData.map((item) =>
        item._id === itemId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const addToOrder = async (item) => {
    // console.log(item);
    const orderData = {
      id: item._id,
      name: item.name,
      itemType: item.itemType || "",
      description: item.description || "",
      quantity: item.quantity,
      price: item.price,
      ingredients: item.ingredients || [],
      dealItems: item?.dealItems || [],
    };

    // await setOrder((prevOrders) => [...prevOrders, orderData]);
    await setOrder((prevOrders) => {
      const existingOrderIndex = prevOrders.findIndex(
        (order) => order.id === item._id
      );

      if (existingOrderIndex !== -1) {
        return prevOrders.map((order, index) =>
          index === existingOrderIndex
            ? { ...order, quantity: order.quantity + item.quantity }
            : order
        );
      } else {
        return [...prevOrders, orderData];
      }
    });

    handleQuantityChange(item._id, 1);
  };

  useEffect(() => {
    if (category) {
      getItemByCategory(category);
    }
  }, [category]);
  useEffect(() => {
    dispatch(filterOrderItems({ search, data }));
  }, [dispatch, search, data]);

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="flex flex-col h-screen bg-[#F1F1F1]">
        {/* Navbar */}

        <Navbar page="Order" />

        <CategorySlider />
        <div className="flex  overflow-hidden h-full">
          <div className="flex flex-1 flex-col p-8 overflow-y-auto scrollbar-hide">
            {filteredItems ? (
              <>
                <div className="flex lg:justify-end justify-start my-4 items-center ">
                  <input
                    type="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-xl outline-none"
                    placeholder="Search by name..."
                  />
                </div>
                <div className="flex  justify-start  gap-4 w-full flex-wrap">
                  {filteredItems.map((item, index) => (
                    <div
                      key={index}
                      className="w-full border-b-2 border-[#807f7fa8] pb-4 flex lg:flex-row flex-col justify-between lg:items-end gap-2"
                    >
                      <div className="flex flex-col justify-center lg:w-[50%] w-full">
                        <span className=" capitalize text-[#0D868C] font-semibold text-[1.3rem]">
                          {item.name}
                        </span>
                        <span className=" capitalize text-[.9rem] text-[#5e5e5e]">
                          {item.description}
                        </span>
                      </div>
                      <div className="">
                        <Counter
                          quantity={item.quantity}
                          onQuantityChange={(newQuantity) =>
                            handleQuantityChange(item._id, newQuantity)
                          }
                          textSize="text-[1.3rem] lg:text-[1.5rem]"
                          textColor="text-[#585858]"
                        />
                      </div>
                      <div className="flex flex-col gap-4 lg:items-end justify-center ">
                        <span className="text-[1.2rem] font-medium ">
                          {priceSymbol} {item.price}
                        </span>
                        <button
                          onClick={() => addToOrder(item)}
                          className="bg-[#0D868C] py-2 px-5 rounded-3xl w-max font-semibold text-white"
                        >
                          Add to Order
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="flex items-center justify-center h-full">
                <div className="w-[19rem] lg:w-[30rem]  relative  lg:h-[24rem] h-[16rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                  <img
                    src={itemLogo}
                    className="mb-4 lg:w-[10rem] w-[5rem]"
                    alt="Logo"
                  />
                  <p className="text-[.9rem] lg:text-[1.2rem] font-inter-700 text-center">
                    You have no items with {category} yet
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-2 lg:w-[35%] w-[40%] bg-white">
            <Order
              tableNo={tableNo}
              order={order}
              setOrder={setOrder}
              option={option}
              setOption={setOption}
              deliveryData={deliveryDatas}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemByCategory;
